import React, {useMemo} from 'react';
import {BaseSpinnerProps} from './types';
import {useStyle} from '../base/hooks';

export const BaseSpinner: React.FC<BaseSpinnerProps> = ({
  size = 24,
  color = '#121221',
  tintColor = '#29293D',
}) => {
  const animation = useMemo(
    () => ({
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    }),
    [],
  );
  const className = useStyle(
    () => ({
      animationName: [animation],
      animationDuration: '1000ms',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
    }),
    [animation],
  );
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="18"
        cy="18"
        r="16"
        stroke={color}
        strokeOpacity="0.1"
        strokeWidth="4"
      />
      <path
        d="M18 2C20.1012 2 22.1817 2.41385 24.1229 3.21793C26.0641 4.022 27.828 5.20055 29.3137 6.68629C30.7994 8.17203 31.978 9.93586 32.7821 11.8771C33.5861 13.8183 34 15.8989 34 18"
        stroke={tintColor}
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
};
